export const footerContent = {
  es: {
    howToContact: 'Contacto:',
  },
  en: {
    howToContact: 'Contact:'
  }
}
